<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" content="添加商品"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<el-form-item label="商品名称" prop="name">
				<el-input v-model="item.name" placeholder="请输入商品名称"></el-input>
			</el-form-item>
			<el-form-item label="所属品牌" prop="brand_id">
				<el-select v-model="item.brand_id" filterable placeholder="请选择">
					<el-option v-for="item in brandList" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="平台分类" prop="product_category_id">
				<el-cascader v-model="item.product_category_id" placeholder="请选择" :options="adminCategoryList"
					:props="filterProps" clearable filterable></el-cascader>
			</el-form-item>
			<el-form-item label="商品分类" prop="supplier_category_id">
				<el-cascader v-model="item.supplier_category_id" placeholder="请选择" @change="changeCategory"
					:options="supplierCategoryList" :props="filterProps" clearable filterable></el-cascader>
			</el-form-item>
			<el-form-item label="运费模板" prop="delivery_id">
				<el-select v-model="item.delivery_id" filterable placeholder="请选择">
					<el-option v-for="item in deliverys" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
<!--			<el-form-item label="选择模板" prop="industryTemplateId">-->
<!--				<el-select v-model="item.industryTemplateId" filterable placeholder="请选择" @change="changeParameter">-->
<!--					<el-option v-for="item in industryTemplateList" :key="item.id" :label="item.name" :value="item.id">-->
<!--					</el-option>-->
<!--				</el-select>-->
<!--			</el-form-item>-->
			<el-form-item :label="list.itemKey" v-for="(list,index) in parameter">
				<el-input v-if="list.dataType == 1" v-model="list.itemValue" placeholder="请输入参数"></el-input>
				<el-date-picker v-else-if="list.dataType == 2" v-model="list.itemValue" type="date" placeholder="选择日期">
				</el-date-picker>
				<el-date-picker v-else-if="list.dataType == 3" v-model="list.itemValue" type="datetime"
					placeholder="选择日期时间">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="商品编码">
				<el-input v-model="item.sku_no" placeholder="请输入商品编码" readonly></el-input>
			</el-form-item>
			<!-- <el-input v-model="item.caption" placeholder="请输入商品规格"></el-input> -->
			<div>
				<div class="goods-spec">
					<el-button size="big" type="primary" @click="addPrivateSpec">点击添加规格</el-button>
<!--					<el-link type="primary" @click="addPrivateSpec" class="goods-spec-add" style="">点击添加规格</el-link>-->
				</div>
				<div class="goods-container" v-for="(attr, index) in privateGoodsItem" :key="index">
					<div class="goods-content">
						<div class="goods-content-box">
							<div class="goods-content-left">
								<el-form-item label="规格名">
									<el-input v-model="attr.privateSpecName" placeholder="请输入规格名"></el-input>
								</el-form-item>
								<el-form-item label="规格值">
									<el-tag v-for="tag in attr.dynamicTags" :key="tag" closable
										:disable-transitions="false" @close="handleClose(tag, attr)">
										{{tag}}
									</el-tag>
									<!--  inputVisible控制是否显示  inputValue值 -->
									<!-- @keyup.enter.native点击回车的时候 判断是否有值决定是否隐藏 -->
									<!-- input失焦blur的时候 判断是否有值决定是否隐藏-->
									<el-input class="input-new-tag" v-show="attr.inputVisible" v-model="attr.inputValue"
										:ref="`saveTagInput${index}`" size="small"
										@keyup.enter.native="handleInputConfirm(attr.inputValue, attr)"
										@blur="handleInputConfirm(attr.inputValue, attr)"></el-input>
									<el-button v-show="!attr.inputVisible" class="button-new-tag" size="small"
										@click="showInput(attr, index)">+ 添加</el-button>
								</el-form-item>
							</div>
							<div class="goods-content-right">
								<el-link type="danger" @click="delPrivateSpec(index)">删除规格</el-link>
							</div>
						</div>
					</div>
				</div>
				<el-table style="margin-bottom: 22px; margin-top:0;" :data="oneFormBatch" border tooltip-effect="dark">
					<el-table-column label="规格">
						<template slot-scope="scope">
							批量设置
						</template>
					</el-table-column>
					<el-table-column label="图片">
						<template slot-scope="scope">
							<el-upload
									class="single-image single-image-small"
									list-type="single-image"
									:on-success="(value) => uploadSuccess1('oneFormBatch', 'single', value, scope.$index)"
									:show-file-list="false"
									:before-upload="beforeUpload"
									:action="app_url + '/store/uploader/upload'">
								<i class="icon el-icon-plus" v-if="!oneFormBatch[scope.$index].product_image"></i>
								<img :src="oneFormBatch[scope.$index].product_image" v-else>
							</el-upload>
						</template>
					</el-table-column>
					<el-table-column label="库存（件）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.stock"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="销售价（元）">
					<template slot-scope="scope">
						<el-input v-model="scope.row.price"></el-input>
					</template>
					</el-table-column>
					<el-table-column label="成本价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.cost"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="市场价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.market_price"></el-input>
						</template>
					</el-table-column>
<!--					<el-table-column label="Sku编码">-->
<!--						<template slot-scope="scope">-->
<!--							<el-input v-model="scope.row.product_sku_no" ></el-input>-->
<!--						</template>-->
<!--					</el-table-column>-->
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button @click="batchAdd" type="success">批量添加</el-button>
							<el-button @click="batchDel" type="primary">清空</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-table style="margin-bottom: 22px; margin-top:0;" ref="multipleTable"
					:data="tableColumnList.tableBodyList" border tooltip-effect="dark">
					<el-table-column :label="item.propName" :property="item.prop"
						v-for="item in tableColumnList.tableHeaderList" :key="item.prop" align="center">
						<template slot-scope="scope">
							<span>{{ scope.row[scope.column.property] }}</span>
						</template>
					</el-table-column>
					<el-table-column label="图片">
						<template slot-scope="scope">
							<el-upload
									class="single-image single-image-small"
									list-type="single-image"
									:on-success="(value) => uploadSuccess1('product_image', 'single', value, scope.$index)"
									:show-file-list="false"
									:before-upload="beforeUpload"
									:action="app_url + '/store/uploader/upload'">
								<i class="icon el-icon-plus" v-if="!tableColumnList.tableBodyList[scope.$index].product_image"></i>
								<img :src="tableColumnList.tableBodyList[scope.$index].product_image" v-else>
							</el-upload>
						</template>
					</el-table-column>
					<el-table-column label="库存（件）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.stock"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="销售价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.price"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="成本价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.cost"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="市场价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.market_price"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="Sku编码">
						<template slot-scope="scope">
							<el-input v-model="scope.row.product_sku_no" readonly></el-input>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<el-form-item label="商品主图" prop="product_pic_main">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('product_pic_main', 'single', value)"
						:show-file-list="false"
						:before-upload="beforeUpload"
						:action="app_url + '/supplier/uploader/upload'">
					<i class="icon el-icon-plus" v-if="!item.product_pic_main"></i>
					<img :src="item.product_pic_main" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item label="细节图" prop="product_images">
				<div>
					<ul class="el-upload-list el-upload-list--picture-card">
						<li :tabindex="index" class="el-upload-list__item is-success" v-for="(src, index) in item.product_images" :key="index">
							<img :src="src" alt="" class="el-upload-list__item-thumbnail">
							<label class="el-upload-list__item-status-label">
								<i class="el-icon-upload-success el-icon-check"></i>
							</label>
							<i class="el-icon-close"></i><i class="el-icon-close-tip">按 delete 键可删除</i>
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview">
									<i class="el-icon-zoom-in"></i></span>
								<span class="el-upload-list__item-delete" @click="delectImage('product_images', index)">
									<i class="el-icon-delete"></i>
								</span>
							</span>
						</li>
					</ul>
					<el-upload
							style="display: inline"
							:multiple="true"
							:limit="10 - item.product_images.length"
							:action="app_url + '/supplier/uploader/upload'"
							:before-upload="beforeUpload"
							list-type="picture-card"
							:show-file-list="false"
							:on-success="(value) => uploadSuccess('product_images', 'multi', value)">
						<i class="el-icon-plus"></i>
					</el-upload>
				</div>
			</el-form-item>
			<el-form-item label="副标题">
				<el-input v-model="item.caption" placeholder="请输入副标题"></el-input>
			</el-form-item>
<!--			<el-form-item label="是否上架">-->
<!--				<el-switch v-model="item.is_marketable" :active-value="'1'" :inactive-value="'0'" active-color="#13ce66" inactive-color="#cccccc">-->
<!--				</el-switch>-->
<!--			</el-form-item>-->
			<el-form-item label="商品详情" id="quill-upload">
				<el-upload :action="app_url + '/supplier/uploader/upload'"  multiple :show-file-list="false" :before-upload="beforeUpload" :on-success="editorSuccess"
					:on-error="uploadError" style="display: none;">
				</el-upload>
				<quill-editor ref="quill" v-model="item.introduction" :options="editorOption" />
			</el-form-item>
			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit" v-auth="['supplier/product/add']">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import {
		quillEditor
	} from 'vue-quill-editor'
	export default {
		data() {
			return {
				item: {
					product_pic_main: '',
					product_images: []
				},
				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				product_images: [],
				product_pic_main: [],
				radio: "",
				filterProps: {
					value: 'id',
					label: 'name',
					emitPath: false,
					checkStrictly: true
				},
				supplierCategoryList: [], // 供应商商品分类列表
				brandList: [], // 品牌列表
				adminCategoryList: [], // 平台商品分类列表
				industryTemplateList: [], // 行业模板
				parameter: [],
				deliverys: [],
				tableColumnList: {
					tableHeaderList: [
						// '颜色', '尺寸', '重量',
					],
					tableBodyList: [{
						// 尺寸: "X",
						// 重量: "轻",
						// 颜色: "红",
						// number: '6'
					}]
				},
				// 批量设置表格data
				oneFormBatch: [
					{
						price: 0,
						market_price: 0,
						cost: 0,
						stock: 0,
						product_image: '',
						product_sku_no: ''
					},
				],
				// 规格项的值和规格值
				privateGoodsItem: [],
				// 方法的变量
				goods_option: [],

				editorOption: {
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'],
								['blockquote', 'code-block'],
								[{
									'header': 1
								}, {
									'header': 2
								}],
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}],
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}],
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}],
								[{
									'direction': 'rtl'
								}],
								[{
									'size': ['small', false, 'large', 'huge']
								}],
								[{
									'header': [1, 2, 3, 4, 5, 6, false]
								}],
								[{
									'color': []
								}, {
									'background': []
								}],
								[{
									'font': []
								}],
								[{
									'align': []
								}],
								['clean'],
								['image', 'video']
							],
							handlers: {
								image: function(value) {
									if (value)
										document.querySelector('#quill-upload input').click()
									else
										this.quill.format('image', false);
								}
							}
						}
					},
				},
				rules: {
					name: [{
						required: true,
						message: '商品名称不存在',
						trigger: 'blur'
					}],
					brand_id: [{
						required: true,
						message: '请选择所属品牌'
					}],
					product_category_id: [{
						required: true,
						message: '请选择平台分类'
					}],
					supplier_category_id: [{
						required: true,
						message: '请选择商品分类'
					}],
					// industryTemplateId: [{
					// 	required: true,
					// 	message: '请选择模板'
					// }],
					product_images: [{
						required: true,
						message: '细节图不存在'
					}],
					product_pic_main: [{
						required: true,
						message: '商品主图不存在'
					}]
				}
			}
		},
		created() {
			this.loadData()
		},
		computed: {
			// 规格发生变化的时候执行
			calculateAttribute() {
				let obj = {}
				// 规格数组，添加一个规格，里面就多一个
				this.privateGoodsItem.forEach((item) => {
					//privateSpecName 规格名
					if (item.privateSpecName) {
						// privateSpecName做键 item.dynamicTags做值
						//  规格名做键 规格值做值
						obj[item.privateSpecName] = item.dynamicTags
					}
				})
				// obj：[array(1),array(2)]
				return obj
			}
		},
		watch: {
			// 规格发生变化的时候执行 newVal就是上面的obj
			calculateAttribute(newVal) {
				// JSON.stringify() 方法用于将 JavaScript 值转换为 JSON 字符串。
				// JSON.parse() 方法将数据转换为 JavaScript 对象。
				let cloneNewVal = JSON.parse(JSON.stringify(newVal))
				let attrName = []
				let attrValue = []
				// cloneNewVal 里面 privateSpecName做键 item.dynamicTags做值
				for (let key in cloneNewVal) {
					// attrName 存储规格名
					attrName.push(key)
					// attrValue 存规格值
					attrValue.push(cloneNewVal[key])
				}
				// 将一维数组中的字符串拆为多维数组
				let finalArr = this.cartesianProductOf(...attrValue)
				let tableObj = {
					tableBodyList: [],
					tableHeaderList: []
				}
				// map转格式且拼接
				tableObj.tableBodyList = finalArr.map((item) => {
					// 新建obj {规格值：规格名，id:"",price:""}
					let obj = {
						// this.goods_option[item.join('|')]是否存在 存在的话this.goods_option[item.join('|')]
						id: this.goods_option[item.join('|')] ? tthis.goods_option[item.join('|')] : '',
						// 价格
						price: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].price : '',
						stock: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].stock : '',
						product_image: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].product_image : '',
						product_sku_no: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].product_sku_no : ''
					}
					// 因为已经交叉起来了,所以length有几个规格项就有几个
					for (let i = 0; i < item.length; i++) {
						// // attrName 存储规格名作为obj的键
						obj[attrName[i]] = item[i]
					}
					return obj
				})
				// {规格值：规格名，id:"",price:""}
				this.tableColumnList.tableBodyList = tableObj.tableBodyList
				// 获取规格项
				let skuTableArr = Object.keys(newVal)
				tableObj.tableHeaderList = skuTableArr.map((item) => {
					return {
						prop: item,
						propName: item
					}
				})
				this.tableColumnList.tableHeaderList = tableObj.tableHeaderList
			}
		},
		methods: {
			// 批量添加
			batchAdd() {
				for (let val of this.tableColumnList.tableBodyList) {
					if (this.oneFormBatch[0].price > 0) {
						this.$set(val, "price", this.oneFormBatch[0].price);
					}
					if (this.oneFormBatch[0].market_price > 0) {
						this.$set(val, "market_price", this.oneFormBatch[0].market_price);
					}
					if (this.oneFormBatch[0].cost > 0) {
						this.$set(val, "cost", this.oneFormBatch[0].cost);
					}
					if (this.oneFormBatch[0].stock > 0) {
						this.$set(val, "stock", this.oneFormBatch[0].stock);
					}

					if (this.oneFormBatch[0].product_image != '') {
						this.$set(val, "product_image", this.oneFormBatch[0].product_image);
					}
					if (this.oneFormBatch[0].product_sku_no != '') {
						this.$set(val, "product_sku_no", this.oneFormBatch[0].product_sku_no);
					}
				}
			},
			batchDel() {
				this.oneFormBatch = [
					{
						price: 0,
						market_price: 0,
						cost: 0,
						stock: 0,
						product_image: '',
						product_sku_no: ''
					},
				];
			},
			changeCategory(data) {
				let categoryId = data[0]
				this.$set(this.item, 'industryTemplateId', '')
				// 根据商品分类ID获取对应的行业模板列表
				this.axios.get('/supplier/data/getIndustryTemplateListByProductCategoryId', {
					params: {
						id: categoryId
					}
				}).then(res => {
					this.industryTemplateList = res.data
				})
			},
			changeParameter(data) {
				let templateId = data
				this.axios.get('/supplier/data/getTemplateItemListByIndustryTemplateId', {
					params: {
						id: templateId
					}
				}).then(res => {
					this.parameter = res.data
				})
			},
			loadData: async function() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad

				// 供应商：商品分类树
				await this.axios.get('/supplier/data/getCategoryTreeSupplier', {}).then(res => {
					this.supplierCategoryList = res.data.tree

				}).catch(() => {
				})

				// 中控：商品分类树
				await this.axios.get('/supplier/data/getCategoryTreeAdmin', {}).then(res => {
					this.adminCategoryList = res.data.tree
				})

				// 品牌列表
				await this.axios.get('/supplier/data/listBrandForSelect', {}).then(res => {
					this.brandList = res.data.list
				})

				await this.axios.get('/supplier/delivery/list', {}).then(res => {
					this.deliverys = res.data.list
				}).catch(() => {
				})
				this.isLoad = false
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				// 存储图片且刷新 因为上传的和存储的图片不是同一个
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}

				this.isLoad = !this.isLoad

				this.item.attr = this.parameter
				// 如果存在多规格的话 就将值传上去
				// this.item.attr2 = this.privateGoodsItem
				// this.item.option = this.tableColumnList

				// 解析多规格
				let specifications = [];
				this.privateGoodsItem.forEach((item) => {
					//privateSpecName 规格名
					//dynamicTags 规格值
					if (item.privateSpecName) {
						let obj = {}
						obj.specName = item.privateSpecName;
						obj.specValue = item.dynamicTags.join(",");
						specifications.push(obj);
					}

				})
				this.item.specification = specifications;

				if(this.item.specification.length == 0){
					this.$message.error('规格不能为空');
					this.isLoad = !this.isLoad
					return false;
				}

				// 解析SKU
				let sku = [];
				var error = 0;
				this.tableColumnList.tableBodyList.forEach((item) => {
					let obj = {}
					obj.cost = item.cost;
					obj.market_price = item.market_price;
					obj.price = item.price;
					obj.stock = item.stock;
					if (item.stock == undefined || item.stock === '') {
						error = 1;
						return this.$message.success({
							message: '库存不能为空'
						});
					}
					obj.product_image = item.product_image;
					obj.product_sku_no = item.product_sku_no;
					let skuName = '';
					this.tableColumnList.tableHeaderList.forEach((i) => {
						if (skuName != '') {
							skuName += ',';
						}
						skuName += item[i.propName];
					})
					obj.skuName = skuName;

					sku.push(obj);
				})
				if (error) {
					return false;
				}
				this.item.sku = sku;

				let url = '/supplier/product/add'
				var form = JSON.parse(JSON.stringify(this.item))
				this.axios.post(url, form)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.$router.push({
							path: '/Goods/unreviewed.html'
						});
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			// 使用数组的index来控制规格项的多少
			addPrivateSpec() {
				this.privateGoodsItem.push({
					privateSpecName: '',
					dynamicTags: [],
					inputVisible: false,
					inputValue: ''
				})
			},
			delPrivateSpec(index) {
				this.privateGoodsItem.splice(index, 1)
			},
			handleInputConfirm(val, attr) {
				// 判断有没有值
				if (val) {
					// 有值的话就添加
					attr.dynamicTags.push(val)
				}
				//  没有值的话就清空 且 隐藏
				attr.inputVisible = false
				attr.inputValue = ''
			},
			handleClose(tag, item) {
				item.dynamicTags.splice(item.dynamicTags.indexOf(tag), 1)
			},
			showInput(attr, index) {
				attr.inputVisible = true
				this.$nextTick(() => {
					this.$refs[`saveTagInput${index}`][0].$refs.input.focus()
				})
			},
			// 将数组拆分，并且交叉！
			cartesianProductOf(...args) {
				return args.reduce((total, current) => {
					let ret = []
					total.forEach((a) => {
						current.forEach((b) => {
							ret.push(a.concat([b]))
						})
					})
					return ret
				}, [
					[]
				])
			},


			uploadError() {
				this.$message.error({
					message: '上传失败'
				});
			},
			beforeUpload(file) {
				var testmsg = file.type;
				const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
				if (!extension) {
					this.$message({
						message: "上传文件只能是jpg或png格式!",
						type: "warning",
					});
					return false;
				}

				const isLt500KB = file.size / 1024 / 1024 < 5;
				if (!isLt500KB) {
					this.$message({
						message: "上传的文件大小不能超过 5M!",
						type: "warning",
					});
					return false;
				}
				return extension;
			},
			uploadSuccess(key, model, res, file) {
				if (model == 'single') {
					this.item[key] = res.data.fileInfo.external_url
				} else {
					this.item[key].push(res.data.fileInfo.external_url)
				}

			},
			uploadSuccess1(key, model, res, index) {
				this.tableColumnList.tableBodyList[index].product_image = res.data.fileInfo.external_url
				this.$forceUpdate()
			},
			delectImage: function (key, index) {
				this.item[key].splice(index, 1)
			},
			// 富文本图片上传
			editorSuccess(res) {
				let quill = this.$refs.quill.quill
				let length = quill.getSelection().index
				// 上传图片的路径
				quill.insertEmbed(length, 'image', res.data.fileInfo.external_url)
				quill.setSelection(length + 1)
				this.$message.success({
					message: '上传成功'
				});
			}
		},
		components: {
			quillEditor
		}
	}
</script>
<style scoped>
	.goods-spec {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.goods-spec .goods-spec-add {
		margin-left: 30px;
		margin-bottom: 14px;
	}

	.goods-container .button-new-tag {
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.goods-container .input-new-tag {
		width: 90px;
		margin-right: 10px;
		vertical-align: bottom;
	}

	.goods-container .el-tag {
		margin-right: 10px;
	}

	.goods-container .goods-content {
		margin-bottom: 10px;
		padding: 14px;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		background-color: #fcfcfc;
	}

	.goods-content .goods-content-box {
		display: flex;
		align-items: center;
	}

	.goods-content-box .goods-content-left {
		flex: 1;
	}

	.single-image .icon,.single-image img{
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		width: 148px;
		height: 148px;
		cursor: pointer;
		line-height: 146px;
		vertical-align: top;
	}
	/deep/.ql-container{
		min-height: 200px;
	}
</style>
